import FORM_AUDIENCE_TYPE from '../../../../constants/FormAudienceType';
import {FORM_ACCESS_LEVELS} from '../../../../constants/formAccessLevels';

/**
 * AD-2639: a response belongs to a child when the form goes to parents or students, is linked to a
 * student, or is an application or acceptance form. Only those responses have a Documents section to
 * be saved to.
 */
export const responsesBelongToAChild = ({audience, linkToStudents, accessLevel, isCommunication}) => {
    if (isCommunication) {
        return false;
    }

    return audience === FORM_AUDIENCE_TYPE.parentsForChildCompletion ||
        audience === FORM_AUDIENCE_TYPE.students ||
        !!linkToStudents ||
        accessLevel === FORM_ACCESS_LEVELS.publicWithStudentLink;
};
